module.exports = __webpack_public_path__ + "static/media/vishruth.5ea27c7d.jpg";